exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-nav-desktop-shop-menu .section-title[data-v-54369cec] {\n  border-bottom: 1px solid #e0e0e0;\n}\n.site-nav-desktop-shop-menu .category-padding[data-v-54369cec] {\n  padding-left: 1em;\n  padding-right: 1em;\n}\n.site-nav-desktop-shop-menu li.sub-menu-item[data-v-54369cec] {\n  padding: 0.5em 0;\n}\n", ""]);

// exports
